import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { ActionButton } from "../../../../../../_metronic/_partials/controls/ActionButton";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption
} from "../../../../../../_metronic/_helpers";
import { toast } from "react-toastify";
import { getGradeOrg } from "../../../_redux/dashboard/dashboardCrud";

export default function GradeOrgModal({ typeGrade, show, closeModal }) {
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10
  });

  const [data, setData] = useState({
    activePage: 1,
    items: [],
    pageNumber: 10,
    total_items: 0,
  });

  async function fetchGradeOrgByType(typeGrade, queryParams) {
    try {
      const res = await getGradeOrg(typeGrade, queryParams.pageNumber, queryParams.pageSize);
      const data = res.data.data;

      setData(data);

    } catch (err) {
      toast.error(err.message, toastOption);
    }
  }

  const {
    actionsLoading,
    auth
  } = useSelector(
    state => ({
      actionsLoading: state.superAdminOrganization.actionsLoading,
      auth: state.auth
    }),
    shallowEqual
  );

  const columns = [
    {
      dataField: "name",
      text: "Nama Lembaga",
      classes: "text-nowrap"
    },
    {
      dataField: "total_donation",
      text: "Pertambahan Donasi",
      classes: "text-nowrap"
    },
    {
      dataField: "total_report_expense",
      text: "Aktivitas Penyaluran Project",
      classes: "text-nowrap"
    },
    {
      dataField: "total_login",
      text: "Aktif Login Aplikasi SIMPZ",
      classes: "text-nowrap"
    },
    {
      dataField: "total_donatur",
      text: "Pertambahan Donatur",
      classes: "text-nowrap"
    },    
    {
      dataField: "ongoing_project",
      text: "Jumlah Project Berjalan",
      classes: "text-nowrap"
    }
  ];

  const paginationOptions = {
    custom: true,
    totalSize: data.total_items === null ? 0 : data.total_items,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "50",
        value: 50
      }
    ],
    sizePerPage: data.pageNumber === null ? 0 : data.pageNumber,
    page: data.activePage === null ? 0 : data.activePage
  };

  useEffect(() => {
    if (typeGrade) {
      fetchGradeOrgByType(typeGrade, queryParams);
    }
  }, [typeGrade, queryParams])

  return (
    <>
      <Modal
        size="xl"
        show={show}
        centered
        onHide={closeModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Daftar Grade Lembaga
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={actionsLoading}
                  paginationProps={paginationProps}
                >
                  <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={false}
                      remote
                      keyField="uuid"
                      data={data?.items}
                      columns={columns}
                      onTableChange={getHandlerTableChange(setQueryParams)}
                      {...paginationTableProps}
                    >
                      <PleaseWaitMessage entities={data?.items} />
                      <NoRecordsFoundMessage entities={data?.items} />
                    </BootstrapTable>
                  </div>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center">
            <ActionButton
              type="button"
              loading={actionsLoading}
              style={{ width: "75px", height: "35.59px" }}
              className="btn btn-primary btn-elevate mx-1"
              onClick={closeModal}
              text="Tutup"
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
